// Material Dashboard 2 PRO React TS Base Styles
import colors from '@theme/base/colors';
import typography from '@theme/base/typography';
import borders from '@theme/base/borders';

const { info, grey } = colors;
const { size } = typography;
const { borderWidth } = borders;

// types
type Types = any;

const input: Types = {
  styleOverrides: {
    root: {
      fontSize: size.sm,
      color: grey[700],

      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `${borderWidth[1]} solid ${grey[400]}`
      },

      '&:before': {
        borderColor: grey[400]
      },

      '&:after': {
        borderColor: info.main
      }
    }
  }
};

export default input;
